import { render, staticRenderFns } from "./bimArticleEdit.vue?vue&type=template&id=3592f6f6&scoped=true&lang=html&"
import script from "./bimArticleEdit.vue?vue&type=script&lang=js&"
export * from "./bimArticleEdit.vue?vue&type=script&lang=js&"
import style0 from "./bimArticleEdit.vue?vue&type=style&index=0&id=3592f6f6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3592f6f6",
  null
  
)

export default component.exports